import React from 'react';

import AdminLayout from 'layouts/Main.js';
/* import Dashboard from 'views/Dashboard/Dashboard.js'; */
import Dashboard from 'views/Dashboard/NewDashboard.js';
import AuthLayout from 'layouts/Auth.js';

import RegisterPage from 'views/Pages/RegisterPage';
import LockScreenPage from 'views/Pages/LockScreenPage';
import UserProfile from 'views/Pages/UserProfile';
import ErrorPage from 'views/Pages/ErrorPage';
import Login from 'views/Pages/LoginPage.js';
import Logout from 'views/Pages/LogoutPage.js';
import Profile from 'views/Tvendo/Setting/User/Profile';
import RefreshPassword from 'views/Tvendo/Setting/User/RefreshPassword';

// Views socio negocio
import ProviderList from 'views/Tvendo/BusinessPartner/DataMaster/BusinessPartner/Provider';
import ProviderDetail from 'views/Tvendo/BusinessPartner/DataMaster/BusinessPartner/Detail';
import CustomerList from 'views/Tvendo/BusinessPartner/DataMaster/BusinessPartner/Customer';
import CustomerDetail from 'views/Tvendo/BusinessPartner/DataMaster/BusinessPartner/Detail';
import CustomerIncomplete from 'views/Tvendo/BusinessPartner/DataMaster/BusinessPartner/CustomerIncomplete';
import CustomerIncompleteDetail from 'views/Tvendo/BusinessPartner/DataMaster/BusinessPartner/CustomerIncompleteDetail';

import BusinessTurnList from 'views/Tvendo/BusinessPartner/DataMaster/BusinessTurn';
import PaymentTermList from 'views/Tvendo/BusinessPartner/DataMaster/PaymentTerm';
import DocumentTypeList from 'views/Tvendo/BusinessPartner/DataMaster/DocumentType';
import CustomerQueryList from 'views/Tvendo/BusinessPartner/Queries/Customer';

// Views Article
import OrdersByPromotion from 'components/Tvendo/Article/Queries/OrdersByPromotion';
import PromotionsWithLowStock from 'components/Tvendo/Article/Queries/PromotionsWithLowStock';
import PromotionList from 'views/Tvendo/Article/Operations/Promotion/Promotion';
import PromotionDetail from 'views/Tvendo/Article/Operations/Promotion/Detail';

import StockLessList from 'views/Tvendo/Article/Operations/StockLess/StockLess';
import StockLessDetail from 'views/Tvendo/Article/Operations/StockLess/Detail';
import ProviderCustomerList from 'views/Tvendo/Article/Operations/ProviderCustomer/ProviderCustomer';
import MustHaveProductList from 'views/Tvendo/Article/Operations/MustHaveProduct/MustHaveProduct';
import PCustomerDetail from 'views/Tvendo/Article/Operations/ProviderCustomer/Detail';

import Entry from 'views/Tvendo/Inventory/Operations/Entry';
import Output from 'views/Tvendo/Inventory/Operations/Output';
import EntryInventory from 'views/Tvendo/Inventory/Operations/EntryInventory';
import OutputInventory from 'views/Tvendo/Inventory/Operations/OutputInventory';
import Transfer from 'views/Tvendo/Inventory/Operations/Transfer';
import ReturnTransfers from 'views/Tvendo/Inventory/Operations/ReturnTransfers';
import TransferFailed from 'views/Tvendo/Inventory/Operations/FailedTransfers';
import ReasonTransfer from 'views/Tvendo/Inventory/Operations/ReasonTransfers';
import KardexDetail from 'views/Tvendo/Inventory/Operations/KardexDetail';
import TransferDetail from 'views/Tvendo/Inventory/Operations/TransferDetail';

// Toma de inventario
import ResponsableInventario from 'views/Tvendo/Inventory/InventoryTaking/ResponsableInventario';
import Generation from 'views/Tvendo/Inventory/InventoryTaking/Generation';
import GenerationDetail from 'views/Tvendo/Inventory/InventoryTaking/GenerationDetail';

import ProductList from 'views/Tvendo/Article/DataMaster/Product/Product';
import ProductDetail from 'views/Tvendo/Article/DataMaster/Product/Detail.js';
import NegativeMargins from 'components/Tvendo/Article/Queries/NegativeMargins';
import AvailableStock from 'components/Tvendo/Article/Queries/AvailableStock';
// components/Tvendo/WorkingDay/CloseWorkDayList

import StockList from 'views/Tvendo/Article/DataMaster/Stock';
import PriceList from 'views/Tvendo/Article/DataMaster/Price';
import PriceIgvList from 'views/Tvendo/Article/DataMaster/PriceIgv';
import ListPriceList from 'views/Tvendo/Article/DataMaster/PriceList/PriceList';
import ListPriceListDetail from 'views/Tvendo/Article/DataMaster/PriceList/PriceListDetail';
import DiscountScaleList from 'views/Tvendo/Article/DataMaster/DiscountScale';
import DiscountRuleList from 'views/Tvendo/Article/DataMaster/DiscountRule';
import DiscountRuleDetail from 'components/Tvendo/Article/DataMaster/DiscountRule/RuleDetail';
import WarehouseList from 'views/Tvendo/Article/DataMaster/Warehouse';
import MarkList from 'views/Tvendo/Article/DataMaster/Mark/Mark';
import MarkDetail from 'views/Tvendo/Article/DataMaster/Mark/MarkDetail';
import PortfolioList from 'views/Tvendo/Article/DataMaster/Portfolio';
import PortfolioDetail from 'components/Tvendo/Article/DataMaster/Portfolio/PortfolioDetail';
import CategoryList from 'views/Tvendo/Article/DataMaster/Category';
import LineList from 'views/Tvendo/Article/DataMaster/Line';
import FamilyList from 'views/Tvendo/Article/DataMaster/Family';
import SubFamilyList from 'views/Tvendo/Article/DataMaster/SubFamily';
import ManufacturaList from 'views/Tvendo/Article/DataMaster/Manufacturer';
import ProductNewList from 'views/Tvendo/Article/DataMaster/ProductNew/ProductNew';

//views Shopping
import ShoppingList from 'views/Tvendo/Shopping/Operations/List';
import ShoppingDetail from 'views/Tvendo/Shopping/Operations/Detail';
import InvoiceManualList from 'views/Tvendo/Shopping/Operations/Invoices/InvoiceManual';
import InvoiceProviderList from 'views/Tvendo/Shopping/Operations/Invoices/InvoiceProvider';
import InvoiceDetail from 'views/Tvendo/Shopping/Operations/Invoices/InvoiceDetail';
import PriceDiffList from 'views/Tvendo/Shopping/Operations/PriceDiff/PriceDiff';
import OrdenCompra from 'views/Tvendo/Shopping/Operations/OrdenCompra/OrdenCompra';
import OrdenCompraDetalle from 'views/Tvendo/Shopping/Operations/OrdenCompra/OrdenCompraDetalle';

// datos maestro de compras
import AccountList from 'views/Tvendo/Shopping/DataMaster/Account/Account';
import AccountConceptList from 'views/Tvendo/Shopping/DataMaster/Account/AccountConcept/AccountConcept';
import ConceptList from 'views/Tvendo/Shopping/DataMaster/Concept/Concept';
import CostCenterList from 'views/Tvendo/Shopping/DataMaster/CostCenter/CostCenter';
import NCConceptList from 'views/Tvendo/Shopping/DataMaster/ConceptNC/Concept';
import PurchaseSireView from 'views/Tvendo/Shopping/DataMaster/PurchaseSire';
import SalesSireView from 'views/Tvendo/Sale/DataMaster/SalesSire';

//Views Sales
import NewSale from 'views/Tvendo/Sale/Operations/NewSale';
import CreditNoteList from 'views/Tvendo/Sale/Operations/CreditNote/List';
import NCredito from 'views/Tvendo/Sale/Operations/CreditNote/NCredito';

import CreditNoteLeftOverList from 'views/Tvendo/Sale/Operations/CreditNoteLeftOver/List';
import NCLeftOvers from 'views/Tvendo/Sale/Operations/CreditNoteLeftOver/NCLeftOvers';

import OrderMovilList from 'views/Tvendo/Sale/Operations/OrderWebMovil/OrderMovil';
import OrderWebList from 'views/Tvendo/Sale/Operations/OrderWebMovil/OrderWeb';
import OrderCommittedList from 'views/Tvendo/Sale/Operations/OrderWebMovil/OrderCommitted';
//archivo compartido para los detalles del pedido ordm order
import OrdmOrderDetailShared from 'views/Tvendo/Sale/Operations/OrderWebMovil/OrdmOrderDetailShared';

import SaleOrderList from 'views/Tvendo/Sale/Operations/SaleOrder/SaleOrder';
import DigitateOrderList from 'views/Tvendo/Sale/Operations/SaleOrder/DigitateOrder';
import WebOrderList from 'views/Tvendo/Sale/Operations/SaleOrder/SaleOrderWeb';
import RuleApprovedOrderList from 'views/Tvendo/Sale/Operations/SaleOrder/SaleOrderRuleApproved';
import SaleOrderDetail from 'views/Tvendo/Sale/Operations/SaleOrder/SaleOrderDetail';
import SaleProductList from 'views/Tvendo/Sale/Operations/SaleProduct/SaleProduct';

//productos comprometidos
import ProductCommittedList from 'views/Tvendo/Sale/Operations/OrderWebMovil/ProductCommitted/ProductCommitted';
import ProductCommittedDetail from 'views/Tvendo/Sale/Operations/OrderWebMovil/ProductCommitted/ProductCommittedDetail';
import SearchDocumentList from 'views/Tvendo/Sale/Operations/SearchDocument/SearchDocument';

import BossSupervisorList from 'views/Tvendo/Sale/DataMaster/BossSupervisor';
import SupervisorList from 'views/Tvendo/Sale/DataMaster/Supervisor/Supervisor';
import SupervisorDetail from 'views/Tvendo/Sale/DataMaster/Supervisor/SupervisorDetail';

import SellerList from 'views/Tvendo/Sale/DataMaster/Seller/Seller';
import SellerDetail from 'views/Tvendo/Sale/DataMaster/Seller/SellerDetail';
import BureauList from 'views/Tvendo/Sale/DataMaster/Bureau';
import CustomerPortfolioList from 'views/Tvendo/Sale/DataMaster/CustomerPortfolio';
import CustomerBureauList from 'views/Tvendo/Sale/DataMaster/CustomerBureau';
import CustomerPortfolioBureauList from 'views/Tvendo/Sale/DataMaster/CustomerPortfolioBureau';

import DailyCustomerPortfolioList from 'views/Tvendo/Sale/DataMaster/DailyCustomerPortfolio/DailyCustomerPortfolio';
import DailyCustomerPortfolioDetail from 'views/Tvendo/Sale/DataMaster/DailyCustomerPortfolio/Detail';

import RouteList from 'views/Tvendo/Sale/DataMaster/Route';
import ZoneList from 'views/Tvendo/Sale/DataMaster/Zone';
import CustomerRouteList from 'views/Tvendo/Sale/DataMaster/CustomerRoute';

import SaleForceList from 'views/Tvendo/Sale/DataMaster/SaleForce/SaleForce';
import SaleForceDetail from 'views/Tvendo/Sale/DataMaster/SaleForce/SaleForceDetail';

import VisitDayList from 'views/Tvendo/Sale/DataMaster/VisitDay';
import QuotaList from 'views/Tvendo/Sale/DataMaster/Quota/Quota';
import QuotaDetail from 'views/Tvendo/Sale/DataMaster/Quota/QuotaDetail';

import CPQuoteList from 'views/Tvendo/Sale/QuotaBPartner/CPQuote/CPQuote';

//Winter
import CPQuoteWinterList from 'views/Tvendo/Sale/QuotaBPartner/Winter/CPQuoteWinter';
import CPSellerWinterList from 'views/Tvendo/Sale/QuotaBPartner/Winter/CPSellerWinter';
import CPCWinterList from 'views/Tvendo/Sale/QuotaBPartner/Winter/CPCReferenciaWinter';
import CPCWinterRebate from 'views/Tvendo/Sale/QuotaBPartner/Winter/CPCRebateWinter';

//Colgate BIMESTRAL
import CoverageColgateList from 'views/Tvendo/Sale/QuotaBPartner/Colgate/Bimestral/CoverageColgate';
import PeriodColgateList from 'views/Tvendo/Sale/QuotaBPartner/Colgate/Bimestral/PeriodColgate';
import PurchasingQuotaList from 'views/Tvendo/Sale/QuotaBPartner/Colgate/Bimestral/PurchasingQuota';
import CategoryQuotaList from 'views/Tvendo/Sale/QuotaBPartner/Colgate/Bimestral/CategoryQuota';
import GroupQuotaList from 'views/Tvendo/Sale/QuotaBPartner/Colgate/Bimestral/GroupQuota';
import GroupDetailQuotaList from 'views/Tvendo/Sale/QuotaBPartner/Colgate/Bimestral/Detail/GroupQuotaDetail';

//Colgate POR PERIODO
import CuotaCompra from 'views/Tvendo/Sale/QuotaBPartner/Colgate/Periodo/CuotaCompra';
import CuotaCategoria from 'views/Tvendo/Sale/QuotaBPartner/Colgate/Periodo/CuotaCategoria';
import CuotaGrupo from 'views/Tvendo/Sale/QuotaBPartner/Colgate/Periodo/CuotaGrupo';
import CuotaGrupoDetail from 'views/Tvendo/Sale/QuotaBPartner/Colgate/Periodo/Detail/CuotaGrupoDetail';

// Softys
import QuotaCategorySoftys from 'views/Tvendo/Sale/QuotaBPartner/Softys/QuotaCategorySoftys';

//Unilever
import QuotaComprasUnilever from 'views/Tvendo/Sale/QuotaBPartner/Unilever/QuotaCompra';
import QuotaVentasUnilever from 'views/Tvendo/Sale/QuotaBPartner/Unilever/QuotaVenta';

//Verdum
import QuotaSede from 'views/Tvendo/Sale/QuotaBPartner/Verdum/QuotaSede';
import QuotaSupervisor from 'views/Tvendo/Sale/QuotaBPartner/Verdum/QuotaSupervisor';
import QuotaVendedor from 'views/Tvendo/Sale/QuotaBPartner/Verdum/QuotaVendedor';
import QuotaZonal from 'views/Tvendo/Sale/QuotaBPartner/Verdum/QuotaZonal';

//Clorox
import QuotaSedeClorox from 'views/Tvendo/Sale/QuotaBPartner/Clorox/QuotaSedeClorox';
import QuotaSupervisorClorox from 'views/Tvendo/Sale/QuotaBPartner/Clorox/QuotaSupervisorClorox';
import QuotaVendedorClorox from 'views/Tvendo/Sale/QuotaBPartner/Clorox/QuotaVendedorClorox';
import QuotaZonalClorox from 'views/Tvendo/Sale/QuotaBPartner/Clorox/QuotaZonalClorox';
import QuotaProductosClorox from 'views/Tvendo/Sale/QuotaBPartner/Clorox/QuotaProductosClorox';
import CloroxIndicators from 'views/Tvendo/Sale/QuotaBPartner/Clorox/IndicatorsClorox';
import CloroxLinealities from 'views/Tvendo/Sale/QuotaBPartner/Clorox/LinealitiesClorox';
import CloroxProductGroups from 'views/Tvendo/Sale/QuotaBPartner/Clorox/ProductGroupsClorox';
import CloroxProductGroupsDetail from 'views/Tvendo/Sale/QuotaBPartner/Clorox/ProductGroupsCloroxDetail';

// CUOTAS ARCOR
import ArcorDivisions from 'views/Tvendo/Sale/QuotaBPartner/Arcor/Divisions';
import ArcorIndicators from 'views/Tvendo/Sale/QuotaBPartner/Arcor/Indicators';
import QuotaArcorZonals from 'views/Tvendo/Sale/QuotaBPartner/Arcor/QuotaZonals';
import QuotaArcorSedes from 'views/Tvendo/Sale/QuotaBPartner/Arcor/QuotaSedes';
import QuotaArcorSupervisors from 'views/Tvendo/Sale/QuotaBPartner/Arcor/QuotaSupervisors';
import QuotaArcorSellers from 'views/Tvendo/Sale/QuotaBPartner/Arcor/QuotaSellers';
import QuotaArcorProducts from 'views/Tvendo/Sale/QuotaBPartner/Arcor/QuotaProducts';

// CUOTAS WINTER
import WinterIndicators from 'views/Tvendo/Sale/QuotaBPartner/WinterCuotas/Indicators';
import QuotaWinterZonals from 'views/Tvendo/Sale/QuotaBPartner/WinterCuotas/QuotaZonals';
import QuotaWinterSedes from 'views/Tvendo/Sale/QuotaBPartner/WinterCuotas/QuotaSedes';
import QuotaWinterBossSale from 'views/Tvendo/Sale/QuotaBPartner/WinterCuotas/QuotaBossSale';
import QuotaWinterSupervisors from 'views/Tvendo/Sale/QuotaBPartner/WinterCuotas/QuotaSupervisors';
import QuotaWinterSellers from 'views/Tvendo/Sale/QuotaBPartner/WinterCuotas/QuotaSellers';
import PanettoneProductGroups from 'views/Tvendo/Sale/QuotaBPartner/WinterCuotas/Panettone/ProductGroups';
import PanettoneProductGroupsDetail from 'views/Tvendo/Sale/QuotaBPartner/WinterCuotas/Panettone/ProductGroupsDetail';
import PanettoneIndicators from 'views/Tvendo/Sale/QuotaBPartner/WinterCuotas/Panettone/Indicators';
import PanettoneQuotaZonals from 'views/Tvendo/Sale/QuotaBPartner/WinterCuotas/Panettone/QuotaZonals';
import PanettoneQuotaSedes from 'views/Tvendo/Sale/QuotaBPartner/WinterCuotas/Panettone/QuotaSedes';
import PanettoneQuotaBossSale from 'views/Tvendo/Sale/QuotaBPartner/WinterCuotas/Panettone/QuotaBossSale';
import PanettoneQuotaSupervisors from 'views/Tvendo/Sale/QuotaBPartner/WinterCuotas/Panettone/QuotaSupervisors';
import PanettoneQuotaSellers from 'views/Tvendo/Sale/QuotaBPartner/WinterCuotas/Panettone/QuotaSellers';

// Google Forms
import FormSupervisor from 'views/Tvendo/Sale/QuotaBPartner/GoogleForm/FormSupervisor';
import FormSupervisorDetail from 'views/Tvendo/Sale/QuotaBPartner/GoogleForm/Detail/FormSupervisorDetail';
import FormDiccionario from 'views/Tvendo/Sale/QuotaBPartner/GoogleForm/FormDiccionario';

// Bonos
import BonosVentas from 'views/Tvendo/Sale/QuotaBPartner/ReglaParametro/BonosVentas';
import BonosColores from 'views/Tvendo/Sale/QuotaBPartner/ReglaParametro/BonosColores';

// Comisiones
import Commissions from 'views/Tvendo/Sale/QuotaBPartner/Comisiones/Comisiones';
import GroupCommissions from 'views/Tvendo/Sale/QuotaBPartner/Comisiones/GroupCommission';
import TypeWorker from 'views/Tvendo/Sale/QuotaBPartner/Comisiones/TypeWorker';
import BonoZone from 'views/Tvendo/Sale/QuotaBPartner/Comisiones/BonoZone';

// SupervisorParametro
import SupervisorParametro from 'views/Tvendo/Sale/QuotaBPartner/ReglaParametro/SupervisorParam';

// CuotasIncentivos && Reglas
import BaseCuotasIncentivos from 'views/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/CuotasIncentivos';
import BaseRules from 'views/Tvendo/Sale/QuotaBPartner/Rules/BaseRules';
import BaseRulesDetail from 'views/Tvendo/Sale/QuotaBPartner/Rules/Detail/BaseRulesDetail';
import BaseRangeRules from 'views/Tvendo/Sale/QuotaBPartner/Rules/BaseRangeRules';
import MecanicaVentas from 'views/Tvendo/Sale/QuotaBPartner/Mecanica/MecanicaVentas';
import MecanicaVentaDetails from 'views/Tvendo/Sale/QuotaBPartner/Mecanica/Detail/MecanicaDetails';
import SupervisorColgate from 'views/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/ColgateSupervisor';
import SupervisorColgateDetalle from 'views/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/ColgateSupervisorDetalle';
// UNILEVER
import TipoIncentivo from 'views/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/Unilever/TipoIncentivo';
import CanalIncentivo from 'views/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/CanalIncentivo';
import GrupoIncentivo from 'views/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/Unilever/GrupoIncentivo';
import GrupoIncentivoDetails from 'views/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/Unilever/GrupoIncentivoDetails';
import CuotaVendedor from 'views/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/Unilever/CuotaVendedor';
import SupervisorUnilever from 'views/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/Unilever/Supervisor';
import SupervisorUnileverDetalle from 'views/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/Unilever/SupervisorDetalle';
// SOFTYS
import SoftyCandado from 'views/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/Softys/SoftyCandado';
import SoftyGrupo from 'views/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/Softys/SoftyGrupo';
import SoftyGrupoDetails from 'views/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/Softys/SoftyGrupoDetails';
import SoftyCuotaVendedor from 'views/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/Softys/SoftyCuotaVendedor';
import SoftySupervisor from 'views/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/Softys/SoftySupervisor';
import SoftySupervisorDetalle from 'views/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/Softys/SoftySupervisorDetalle';

//Bancos operaciones
import PaymentReceivedList from 'views/Tvendo/Bank/Operations/Payments/PendingPaymentReceived';
import PaymentRecivedDetail from 'views/Tvendo/Bank/Operations/Payments/PendingPaymentDetail';
import PaymentMadeList from 'views/Tvendo/Bank/Operations/Payments/PendingPaymentMade';
import PaymentMadeDetail from 'views/Tvendo/Bank/Operations/Payments/PendingPaymentDetail';
import AccountListView from 'views/Tvendo/Bank/Operations/AccountList';
import DepositList from 'components/Tvendo/Bank/DataMaster/Deposits/DepositList';
import NewDepositView from 'views/Tvendo/Bank/DataMaster/Payments/Deposits/NewDepositView';
//bancos datos maestros
import PaymentRealizedReceivedList from 'views/Tvendo/Bank/DataMaster/Payments/PaymentRealizedReceived';
import PaymentRealizedReceivedDetail from 'views/Tvendo/Bank/DataMaster/Payments/PaymentRealizedDetail';
import PaymentRealizedMadeList from 'views/Tvendo/Bank/DataMaster/Payments/PaymentRealizedMade';
import PaymentRealizedMadeDetail from 'views/Tvendo/Bank/DataMaster/Payments/PaymentRealizedDetail';
import CurrentAccout from 'views/Tvendo/Bank/DataMaster/Payments/CurrentAccout';
import CurrentAccoutDetail from 'views/Tvendo/Bank/DataMaster/Payments/CurrentAccoutDetail';

//Mobile
import CustomerMobileList from 'views/Tvendo/Mobile/Customer';

import MarkedList from 'views/Tvendo/Mobile/Marked';
import MarkedDayList from 'views/Tvendo/Mobile/MarkedDay';

import TracingSellerList from 'views/Tvendo/Mobile/Tracing/Seller';
import TracingMarkList from 'views/Tvendo/Mobile/Tracing/Mark';
import LogList from 'views/Tvendo/Mobile/Log';

//Distribution Operaciones
import ProgrammingList from 'views/Tvendo/Distribution/Operations/Programming/Programming';
import ProgrammingDetail from 'views/Tvendo/Distribution/Operations/Programming/Detail';
//Configuracion y analisis
import ConfigList from 'views/Tvendo/Distribution/Operations/ProgConfiguration/ProgConfiguration';
import ConfigListDetail from 'views/Tvendo/Distribution/Operations/ProgConfiguration/ProgConfigurationDetail';

import WorkingBossList from 'views/Tvendo/Distribution/Operations/WorkingBoss/WorkingBoss';
import WorkingBossDetail from 'views/Tvendo/Distribution/Operations/WorkingBoss/WorkingBossDetail';
import CancelLiquidationList from 'views/Tvendo/Distribution/Operations/CancelLiquidation/CancelLiquidation';
import DistributionTrackingList from 'views/Tvendo/Distribution/Operations/TrackingDist/Distribution';
import DistributionTrackingDetail from 'views/Tvendo/Distribution/Operations/TrackingDist/Detail';
import LiquidationList from 'views/Tvendo/Distribution/Operations/Liquidation/Liquidation';
//Distribution Datos maestros
import DistributionStaffList from 'views/Tvendo/Distribution/DataMaster/DistributionStaff';
import PublicDistributionStaffList from 'views/Tvendo/Distribution/DataMaster/PublicDistributionStaff';
import EmployeeStatusList from 'views/Tvendo/Distribution/DataMaster/EmployeeStatus';
import EmployeePositionList from 'views/Tvendo/Distribution/DataMaster/EmployeePosition';
import VehicleList from 'views/Tvendo/Distribution/DataMaster/Vehicle';
import PublicVehicleList from 'views/Tvendo/Distribution/DataMaster/PublicVehicle';

import AdvanceInvoiceList from 'views/Tvendo/Distribution/Queries/AdvanceInvoice/AdvanceInvoice';
import SettlementAdvance from 'components/Tvendo/Distribution/Queries/SettlementAdvance';

// WorkingDay
import WorkingDayList from 'views/Tvendo/WorkingDay/List';
import CloseWorkDayList from 'components/Tvendo/WorkingDay/CloseWorkDayList';

//comisiones
import RangeList from 'views/Tvendo/Commissions/DataMaster/Range';
import QuotaZoneList from 'views/Tvendo/Commissions/DataMaster/QuotaZone';
import ProviderGroupList from 'views/Tvendo/Commissions/DataMaster/ProviderGroup/ProviderGroup';
import ProviderGroupDetail from 'views/Tvendo/Commissions/DataMaster/ProviderGroup/ProviderGroupDetail';

import IncentiveList from 'views/Tvendo/Commissions/Operations/Incentive/Incentive';
import IncentiveNewUpdate from 'views/Tvendo/Commissions/Operations/Incentive/IncentiveNewUpdate';
import IncentiveRp from 'views/Tvendo/Commissions/Operations/Incentive/IncentiveShow';

// Credentials
import UserList from 'views/Tvendo/Setting/User/List';
import UserDetail from 'views/Tvendo/Setting/User/Detail';

import RoleList from 'views/Tvendo/Setting/Role/List';
import RoleDetail from 'views/Tvendo/Setting/Role/Detail';
import PrintList from 'views/Tvendo/Setting/Print/User';
import PrintDetail from 'views/Tvendo/Setting/Print/DocumentPermission/PrintDetail';
import ReferalGuide from 'views/Tvendo/Print/ReferalGuide';
import ReferalGuideDetail from 'components/Tvendo/Print/ReferalGuideDetail';
import HolidayList from 'views/Tvendo/Setting/Holiday/Holiday';
import VariableList from 'views/Tvendo/Setting/Variable/Variable';
import MobileAppList from 'views/Tvendo/Setting/MobileApp/MobileApp';

import { AuthGuard } from 'components/Tvendo/Common/AuthGuard';
import { GuestGuard } from 'components/Tvendo/Common/GuestGuard';
import { Navigate } from 'react-router-dom';
import { NotFound } from 'containers/NotFound';
import { AuthorizedGuard } from 'components/Tvendo/Common/AuthorizedGuard';
import { ConstantPermissions } from 'contexts/useConstant';
import LastPurchasePrices from 'components/Tvendo/Shopping/Queries/LastPurchasePrices';
import PurchaseDocumentList from 'components/Tvendo/Shopping/Operations/PurchaseDocument/PurchaseDocumentList';
import ComboList from 'components/Tvendo/Article/Operations/Combo/ComboList';
import NewCombo from 'components/Tvendo/Article/Operations/Combo/NewCombo';
import NotificationList from 'components/Tvendo/Setting/Notification/NotificationList';
import CompanyList from 'views/Tvendo/Distribution/DataMaster/Company';
import NotificationDetail from 'components/Tvendo/Setting/Notification/NotificationDetail';
import LayerList from 'components/Tvendo/Sale/DataMaster/Layer/LayerList';
import LayerDivitionList from 'components/Tvendo/Sale/DataMaster/LayerDivition/LayerDivitionList';
import ZoneQuota from 'components/Tvendo/Quota/ZoneQuota';
import Quota from 'views/Tvendo/Quota/Quota';
import NewPurchaseCreditNoteView from 'views/Tvendo/Shopping/Operations/CreditNote/NewPurchaseCreditNoteView';
import PurchaseCreditNoteList from 'components/Tvendo/Shopping/Operations/CreditNote/PurchaseCreditNoteList';
// Nota de debito
import NewPurchaseDebitNoteView from 'views/Tvendo/Shopping/Operations/DebitNote/NewPurchaseDebitNoteView';
import PurchaseDebitNoteList from 'components/Tvendo/Shopping/Operations/DebitNote/PurchaseDebitNoteList';
import ConvertionList from 'components/Tvendo/Inventory/Operations/Convertions/ConvertionList';
import ConvertionDetail from 'views/Tvendo/Inventory/Operations/ConvertionDetail';
import MaterialListIndex from 'components/Tvendo/Inventory/DataMaster/MaterialList/MaterialListIndex';
import NewMaterialList from 'components/Tvendo/Inventory/DataMaster/MaterialList/NewMaterialList';
import ApplicateNCList from 'components/Tvendo/Bank/DataMaster/ApplicateNC/ApplicateNCList';
import ApplicateNC from 'components/Tvendo/Bank/DataMaster/ApplicateNC/ApplicateNC';
import ReconciliationList from 'components/Tvendo/Bank/DataMaster/Reconciliation/ReconciliationList';
import NewReconciliation from 'components/Tvendo/Bank/DataMaster/Reconciliation/NewReconciliation';
import PriceRetentionList from 'components/Tvendo/Article/Operations/PriceRetention/PriceRetentionList';
import PromotionRetentionList from 'components/Tvendo/Article/Operations/PromotionRetention/PromotionRetentionList';
import StatementBank from 'components/Tvendo/Bank/DataMaster2/StatementBank/StatementBankList';
import ClosingList from 'components/Tvendo/Bank/Operations/Closing/ClosingList';
import ClosingShow from 'components/Tvendo/Bank/Operations/Closing/ClosingShow';
import FueraRutaCartera from 'components/Tvendo/Sale/Consultas/FueraRutaCartera';
import ClientesReactivados from 'components/Tvendo/BusinessPartner/Queries/ClientesReactivados';
import ClientesInactivados from 'components/Tvendo/BusinessPartner/Queries/ClientesInactivados';
import ClientesEstados from 'components/Tvendo/BusinessPartner/Queries/ClientesEstados';
import { RouteSales } from 'components/Tvendo/Reports/RouteSales';
import SalesExcel from 'components/Tvendo/Reports/SalesExcel';
import ActivityWhatsapp  from 'views/Tvendo/Reports/Activity/ActivityWhatsapp';
import ContactWhatsapp from 'views/Tvendo/Reports/Contact/ContactWhatsapp';
import FileWhatsapp from 'views/Tvendo/Reports/File/FileWhatsapp';
import FileDetailWhatsapp from 'views/Tvendo/Reports/File/FileDetailWhatsapp';
import AnalisisList from 'views/Tvendo/Reports/ProgAnalisis/ProgAnalisis';
import AnalisisListDetail from 'views/Tvendo/Reports/ProgAnalisis/ProgAnalisisDetail';
// Control de muebles
import CustomerFurnitureList from 'views/Tvendo/BusinessPartner/DataMaster/CustomerFurniture/CustomerFurniture';
import CustomerFurnitureDetail from 'views/Tvendo/BusinessPartner/DataMaster/CustomerFurniture/CustomerFurnitureDetail';
import FurnitureList from 'views/Tvendo/BusinessPartner/DataMaster/Furniture/Furniture';
import FurnitureCategoryList from 'views/Tvendo/BusinessPartner/DataMaster/FurnitureCategory/FurnitureCategory';
import FurnitureSalesCategoryList from 'views/Tvendo/BusinessPartner/DataMaster/FurnitureSalesCategory/FurnitureSalesCategory';


// import AuthLayout from "layouts/Auth.js";

const TvendoRoutes = [
  { path: '', element: <Navigate to="/admin/dashboard" replace /> },
  {
    path: 'auth/*',
    name: 'Seguridad',
    element: <AuthLayout />,
    children: [
      { path: '', element: <Navigate to="/login" replace /> },
      {
        path: 'login',
        name: 'Login',
        element: (
          <GuestGuard>
            <Login />
          </GuestGuard>
        ),
      },
      {
        path: 'login-page',
        name: 'Iniciar sesión',
        element: (
          <GuestGuard>
            <Login />
          </GuestGuard>
        ),
      },
      {
        path: 'register-page',
        name: 'Nuevos clientes',
        element: (
          <GuestGuard>
            <RegisterPage />
          </GuestGuard>
        ),
      },
      {
        path: 'lock-screen-page',
        name: 'Bloquear',
        element: <LockScreenPage />,
      },
      {
        path: 'actualizar-password',
        name: 'Actualizar contraseña',
        element: <RefreshPassword />,
      },
      {
        path: 'user-page',
        name: 'Perfil del usuario',
        component: (
          <AuthGuard>
            <UserProfile />
          </AuthGuard>
        ),
      },
      {
        path: 'logout-page',
        name: 'Cerrar sesión',
        element: (
          <AuthGuard>
            <Logout />
          </AuthGuard>
        ),
      },
      {
        path: 'logout',
        name: 'Cerrar sesión',
        element: (
          <AuthGuard>
            <Logout />
          </AuthGuard>
        ),
      },
      {
        path: 'error-page',
        name: 'Página error',
        component: <NotFound />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
  {
    path: 'admin',
    name: 'Admin',
    element: (
      <AuthGuard>
        <AdminLayout />
      </AuthGuard>
    ),
    children: [
      { path: '', element: <Navigate to="/admin/dashboard" replace /> },
      {
        path: 'perfil',
        name: 'Perfil',
        element: <Profile />,
        permission: ConstantPermissions.OAUTH_USERS_SHOW,
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        element: (
          <AuthGuard>
            <Dashboard />
          </AuthGuard>
        ),
      },
      {
        path: 'socio-negocio',
        children: [
          {
            path: 'datos-maestros',
            children: [
              {
                path: 'clientes',
                children: [
                  {
                    path: '',
                    element: <CustomerList />,
                    permission: ConstantPermissions.BASE_BUSINESS_PARTNERS_CUSTOMER_INDEX,
                  },
                  {
                    path: ':id',
                    element: <CustomerDetail />, //observacion
                  },
                ],
              },
              {
                path: 'proveedor',
                children: [
                  {
                    path: '',
                    element: <ProviderList />,
                    permission: ConstantPermissions.BASE_BUSINESS_PARTNERS_PROVIDER_INDEX,
                  },
                  {
                    path: ':id',
                    element: <ProviderDetail />, //observacion
                  },
                ],
              },
              {
                path: 'incompletos',
                children: [
                  {
                    path: '',
                    element: <CustomerIncomplete />,
                    permission: ConstantPermissions.BASE_BUSINESS_PARTNERS_STORE,
                  },
                  {
                    path: ':id',
                    element: <CustomerIncompleteDetail />,
                  },
                ],
              },
              {
                path: 'giro-negocio',
                element: <BusinessTurnList />,
                permission: ConstantPermissions.BASE_BUSINESS_LINES_INDEX,
              },
              {
                path: 'termino-pago',
                element: <PaymentTermList />,
                permission: ConstantPermissions.BASE_PAYMENT_TERMS_INDEX,
              },
              {
                path: 'tipo-documento',
                element: <DocumentTypeList />,
                permission: ConstantPermissions.BASE_DOCUMENT_TYPES_INDEX,
              },
              {
                path: 'categorias-muebles',
                element: <FurnitureCategoryList />,
                permission: ConstantPermissions.BASE_FURNITURES_INDEX,
              },
              {
                path: 'muebles',
                element: <FurnitureList />,
                permission: ConstantPermissions.BASE_FURNITURES_INDEX,
              },
              {
                //los tramos de venta del cliente, no la categoria del mueble
                path: 'categorias-muebles-venta',
                element: <FurnitureSalesCategoryList />,
                permission: ConstantPermissions.BASE_FURNITURES_INDEX,
              },
              {
                //va debajo de clientes: son clientes con mueble colocado
                path: 'control-muebles',
                children: [
                  {
                    path: '',
                    element: <CustomerFurnitureList />,
                    permission: ConstantPermissions.BASE_FURNITURES_INDEX,
                  },
                  {
                    path: ':id',
                    element: <CustomerFurnitureDetail />,
                  },
                ],
              },
            ],
          },
          {
            path: 'consultas',
            children: [
              {
                path: 'clientes-creados',
                element: <CustomerQueryList />,
                permission: ConstantPermissions.PROM_PROMOTIONS_INDEX,
              },
              {
                path: 'inactivados',
                element: <ClientesInactivados />,
                permission: ConstantPermissions.BASE_BUSINESS_PARTNERS_CUSTOMER_INDEX,
              },
              {
                path: 'reactivados',
                element: <ClientesReactivados />,
                permission: ConstantPermissions.BASE_BUSINESS_PARTNERS_CUSTOMER_INDEX,
              },
              {
                path: 'clientes-mesa-activaciones',
                element: <ClientesEstados />,
                permission: ConstantPermissions.BASE_BUSINESS_PARTNERS_CUSTOMER_INDEX,
              },
            ],
          },
        ],
      },
      {
        path: 'articulos',
        children: [
          {
            path: 'operaciones',
            children: [
              {
                path: 'promociones',
                children: [
                  {
                    path: '',
                    element: <PromotionList />,
                    permission: ConstantPermissions.PROM_PROMOTIONS_INDEX,
                  },
                  {
                    path: ':id',
                    element: <PromotionDetail />, //observacion
                  },
                ],
              },
              {
                path: 'promociones-retenidas',
                children: [
                  {
                    path: '',
                    element: <PromotionRetentionList />,
                    permission: ConstantPermissions.PROM_PROMOTIONS_APPROVE_RETAINED,
                  },
                ],
              },
              {
                path: 'combos',
                children: [
                  {
                    path: '',
                    element: <ComboList />,
                    permission: ConstantPermissions.PROM_PROMOTIONS_INDEX,
                  },
                  {
                    path: ':id',
                    element: <NewCombo />, //observacion
                  },
                ],
              },
              {
                path: 'stock-bonificacion',
                children: [
                  {
                    path: '',
                    element: <StockLessList />,
                    permission: ConstantPermissions.PROM_PROMOTIONS_INDEX, // TODO cambiar cuando se cree el permiso
                  },
                  {
                    path: ':id',
                    element: <StockLessDetail />, //observacion
                  },
                ],
              },
              {
                path: 'proveedor-giro',
                children: [
                  {
                    path: '',
                    element: <ProviderCustomerList />,
                    permission: ConstantPermissions.PROM_PROMOTIONS_INDEX, // TODO cambiar cuando se cree el permiso
                  },
                  {
                    path: ':id',
                    element: <PCustomerDetail />,
                  },
                ],
              },
              {
                path: 'productos-infaltables',
                children: [
                  {
                    path: '',
                    element: <MustHaveProductList />,
                    permission: ConstantPermissions.LOGI_PRODUCTS_INDEX, // TODO cambiar cuando se cree el permiso
                  },
                ],
              },
              {
                path: 'precios-retenidos',
                children: [
                  {
                    path: '',
                    element: <PriceRetentionList />,
                    permission: ConstantPermissions.LOGI_PRICES_APPROVE_RETAINED,
                  },
                  {
                    path: ':id',
                    element: <></>,
                  },
                ],
              },
            ],
          },
          {
            path: 'datos-maestros',
            children: [
              {
                path: 'productos',
                children: [
                  {
                    path: '',
                    element: <ProductList />,
                    permission: ConstantPermissions.LOGI_PRODUCTS_INDEX,
                  },
                  {
                    path: ':id',
                    element: <ProductDetail />, //observacion
                  },
                ],
              },
              {
                path: 'stocks',
                element: <StockList />,
                permission: ConstantPermissions.LOGI_STOCKS_INDEX,
              },
              {
                path: 'precios',
                element: <PriceList />,
                permission: ConstantPermissions.LOGI_PRICES_INDEX,
              },
              {
                path: 'igv-precios',
                element: <PriceIgvList />,
                permission: ConstantPermissions.LOGI_PRICES_IGV_INDEX,
              },
              {
                path: 'lista-precios',
                children: [
                  {
                    path: '',
                    element: <ListPriceList />,
                    permission: ConstantPermissions.LOGI_PRICE_LISTS_INDEX,
                  },
                  {
                    path: ':id',
                    element: <ListPriceListDetail />, //observacion
                  },
                ],
              },
              {
                path: 'escala-descuento',
                element: <DiscountScaleList />,
                permission: ConstantPermissions.LOGI_PRODUCT_DISCOUNT_SCALES_INDEX,
              },
              {
                path: 'regla-descuento',
                children: [
                  {
                    path: '',
                    element: <DiscountRuleList />,
                    permission: ConstantPermissions.LOGI_RULE_DISCOUNTS_INDEX,
                  },
                  {
                    path: ':id',
                    element: <DiscountRuleDetail />,
                  },
                ],
              },
              {
                path: 'almacen',
                element: <WarehouseList />,
                permission: ConstantPermissions.LOGI_WAREHOUSES_INDEX,
              },
              {
                path: 'portfolio',
                children: [
                  {
                    path: '',
                    element: <PortfolioList />,
                    permission: ConstantPermissions.LOGI_PORTFOLIOS_INDEX,
                  },
                  {
                    path: ':id',
                    element: <PortfolioDetail />,
                  },
                ],
              },
              {
                path: 'marca',
                children: [
                  {
                    path: '',
                    element: <MarkList />,
                    permission: ConstantPermissions.LOGI_MARKS_INDEX,
                  },
                  {
                    path: ':id',
                    element: <MarkDetail />,
                  },
                ],
              },
              {
                path: 'categorias',
                children: [
                  {
                    path: '',
                    element: <CategoryList />,
                    permission: ConstantPermissions.LOGI_CATEGORIES_INDEX,
                  },
                  {
                    path: ':categoryId',
                    element: <LineList />,
                  },
                ],
              },
              {
                path: 'lineas',
                children: [
                  {
                    path: '',
                    element: <LineList />,
                    permission: ConstantPermissions.LOGI_LINES_INDEX,
                  },
                  {
                    path: ':lineId',
                    element: <FamilyList />,
                  },
                ],
              },
              {
                path: 'familias',
                children: [
                  {
                    path: '',
                    element: <FamilyList />,
                    permission: ConstantPermissions.LOGI_FAMILIES_INDEX,
                  },
                  {
                    path: ':familyId',
                    element: <SubFamilyList />,
                  },
                ],
              },
              {
                path: 'sub-familias',
                element: <SubFamilyList />,
                permission: ConstantPermissions.LOGI_SUB_FAMILIES_INDEX,
              },
              {
                path: 'manufactura',
                element: <ManufacturaList />,
                permission: ConstantPermissions.LOGI_MANUFACTURERS_INDEX,
              },
              {
                path: 'productos-nuevos',
                children: [
                  {
                    path: '',
                    element: <ProductNewList />,
                    permission: ConstantPermissions.LOGI_PRODUCTS_INDEX,
                  },
                ],
              },
            ],
          },
          {
            path: 'consultas',
            children: [
              {
                path: 'margenes-negativos',
                element: <NegativeMargins />,
                permission: ConstantPermissions.LOGI_PRODUCTS_INDEX,
              },
              {
                path: 'stock-disponible',
                element: <AvailableStock />,
                permission: ConstantPermissions.LOGI_PRODUCTS_INDEX,
              },
              {
                path: 'pedidos-por-promocion',
                element: <OrdersByPromotion />,
                permission: ConstantPermissions.PROM_PROMOTIONS_INDEX,
              },
              {
                path: 'promociones-con-bajo-stock',
                element: <PromotionsWithLowStock />,
                permission: ConstantPermissions.PROM_PROMOTIONS_INDEX,
              },
            ],
          },
        ],
      },
      {
        path: 'inventario',
        children: [
          {
            path: 'datos-maestros',
            children: [
              {
                path: 'lista-materiales',
                children: [
                  {
                    path: '',
                    element: <MaterialListIndex />,
                    permission: ConstantPermissions.LOGI_MATERIAL_LISTS_INDEX,
                  },
                  {
                    path: ':id',
                    element: <NewMaterialList />,
                  },
                ],
              },
            ],
          },
          {
            path: 'operaciones',
            children: [
              {
                path: 'transferencia',
                children: [
                  {
                    path: '',
                    element: <Transfer />,
                    permission: ConstantPermissions.LOGI_TRANSFERS_INDEX,
                  },
                  {
                    path: 'nuevo',
                    element: <TransferDetail />,
                  },
                  {
                    path: ':id',
                    element: <TransferDetail />, //observacion
                  },
                ],
              },
              {
                path: 'conversiones',
                children: [
                  {
                    path: '',
                    element: <ConvertionList />,
                    permission: ConstantPermissions.LOGI_CONVERTIONS_INDEX,
                  },
                  {
                    path: ':id',
                    element: <ConvertionDetail />,
                  },
                ],
              },
              {
                path: 'entradas',
                children: [
                  {
                    path: '',
                    element: <Entry />,
                    permission: ConstantPermissions.LOGI_ENTRIES_INDEX,
                  },
                  {
                    path: 'nuevo',
                    element: <KardexDetail />,
                  },
                  {
                    path: ':id',
                    element: <KardexDetail />, //observacion
                  },
                ],
              },
              {
                path: 'salidas',
                children: [
                  {
                    path: '',
                    element: <Output />,
                    permission: ConstantPermissions.LOGI_OUTPUTS_INDEX,
                  },
                  {
                    path: 'nuevo',
                    element: <KardexDetail />,
                  },
                  {
                    path: ':id',
                    element: <KardexDetail />, //observacion
                  },
                ],
              },
              {
                path: 'devoluciones',
                children: [
                  {
                    path: '',
                    element: <ReturnTransfers />,
                    permission: ConstantPermissions.LOGI_TRANSFERS_INDEX,
                  },
                  {
                    path: 'nuevo',
                    element: <TransferDetail />,
                  },
                  {
                    path: ':id',
                    element: <TransferDetail />, //observacion
                  },
                ],
              },
              {
                path: 'malogrados',
                children: [
                  {
                    path: '',
                    element: <TransferFailed />,
                    permission: ConstantPermissions.LOGI_TRANSFERS_INDEX,
                  },
                  {
                    path: 'nuevo',
                    element: <TransferDetail />,
                  },
                  {
                    path: ':id',
                    element: <TransferDetail />, //observacion
                  },
                ],
              },
              {
                path: 'motivo-transferencia',
                element: <ReasonTransfer />,
                permission: ConstantPermissions.LOGI_TRANSFERS_INDEX,
              },
            ],
          },
          {
            path: 'toma-inventario',
            children: [
              {
                path: 'responsables-inventario',
                children: [
                  {
                    path: '',
                    element: <ResponsableInventario />,
                    permission: ConstantPermissions.LOGI_INVENTORIES_INDEX,
                  },
                ],
              },
              {
                path: 'registro-inventario',
                children: [
                  {
                    path: '',
                    element: <Generation />,
                    permission: ConstantPermissions.LOGI_INVENTORIES_INDEX,
                  },
                  {
                    path: 'nuevo',
                    element: <GenerationDetail />,
                  },
                  {
                    path: ':id',
                    element: <GenerationDetail />,
                  },
                ],
              },
              {
                path: 'entradas-inventario',
                children: [
                  {
                    path: '',
                    element: <EntryInventory />,
                    permission: ConstantPermissions.LOGI_INVENTORIES_INDEX,
                  },
                  {
                    path: 'nuevo',
                    element: <KardexDetail />,
                  },
                  {
                    path: ':id',
                    element: <KardexDetail />, //observacion
                  },
                ],
              },
              {
                path: 'salidas-inventario',
                children: [
                  {
                    path: '',
                    element: <OutputInventory />,
                    permission: ConstantPermissions.LOGI_INVENTORIES_INDEX,
                  },
                  {
                    path: 'nuevo',
                    element: <KardexDetail />,
                  },
                  {
                    path: ':id',
                    element: <KardexDetail />,
                  },
                ],
              },
            ],
          },
        ],
      },

      {
        path: 'compras',
        children: [
          {
            path: 'operaciones',
            children: [
              {
                path: 'importaciones',
                children: [
                  {
                    path: '',
                    element: <ShoppingList />,
                    permission: ConstantPermissions.PURCH_PURCHASES_INDEX,
                  },
                  {
                    path: ':id',
                    element: <ShoppingDetail />, //observacion
                  },
                ],
              },
              {
                path: 'factura',
                children: [
                  {
                    path: '',
                    element: <InvoiceManualList />,
                    permission: ConstantPermissions.PURCH_PURCHASES_INDEX,
                  },
                  {
                    path: ':id',
                    element: <InvoiceDetail />, //observacion
                  },
                ],
              },
              {
                path: 'factura-proveedores',
                children: [
                  {
                    path: '',
                    element: <InvoiceProviderList />,
                    permission: ConstantPermissions.PURCH_PURCHASES_PROVIDER_INDEX,
                  },
                  {
                    path: ':id',
                    element: <InvoiceDetail />, //observacion
                  },
                ],
              },
              {
                path: 'factura-compras',
                children: [
                  {
                    path: '',
                    element: <PurchaseDocumentList />,
                    permission: ConstantPermissions.PURCH_PURCHASES_DOCUMENT_INDEX,
                  },
                ],
              },
              {
                path: 'nota-credito',
                children: [
                  {
                    path: '',
                    element: <PurchaseCreditNoteList />,
                    permission: ConstantPermissions.PURCH_PURCHASES_INDEX,
                  },
                  {
                    path: ':id',
                    element: <NewPurchaseCreditNoteView />,
                  },
                ],
              },
              {
                path: 'nota-debito',
                children: [
                  {
                    path: '',
                    element: <PurchaseDebitNoteList />,
                    permission: ConstantPermissions.PURCH_PURCHASES_INDEX,
                  },
                  {
                    path: ':id',
                    element: <NewPurchaseDebitNoteView />,
                  },
                ],
              },
              {
                path: 'diferencia-precios',
                children: [
                  {
                    path: '',
                    element: <PriceDiffList />,
                    permission: ConstantPermissions.PURCH_PURCHASES_INDEX, //TODO cambiar cuando se cree el permiso
                  },
                ],
              },
              {
                path: 'orden-compra',
                children: [
                  {
                    path: '',
                    element: <OrdenCompra />,
                    permission: ConstantPermissions.PURCH_PURCHASES_INDEX,
                  },
                  {
                    path: ':id',
                    element: <OrdenCompraDetalle />,
                  },
                ],
              },
            ],
          },
          {
            path: 'datos-maestros',
            children: [
              {
                path: 'cuenta',
                children: [
                  {
                    path: '',
                    element: <AccountList />,
                    permission: ConstantPermissions.PYMT_ACCOUNTS_INDEX,
                  },
                  {
                    path: ':id',
                    element: <AccountConceptList />, //observacion
                  },
                ],
              },
              {
                path: 'concepto',
                element: <ConceptList />,
                permission: ConstantPermissions.PYMT_CONCEPTS_INDEX,
              },
              {
                path: 'centro-costo',
                element: <CostCenterList />,
                permission: ConstantPermissions.PYMT_EXPENSE_CENTERS_INDEX,
              },
              {
                path: 'concepto-nota-credito',
                element: <NCConceptList />,
                permission: ConstantPermissions.PYMT_CONCEPTS_INDEX,
              },
              {
                path: 'sire',
                element: <PurchaseSireView />,
                permission: ConstantPermissions.PURCH_SIRE_CONCILIATIONS_INDEX,
              },
            ],
          },
          {
            path: 'consultas',
            children: [
              {
                path: 'ultimos-precios',
                element: <LastPurchasePrices />,
                permission: ConstantPermissions.PURCH_PURCHASES_INDEX,
              },
            ],
          },
        ],
      },
      {
        path: 'ventas',
        children: [
          {
            path: 'operaciones',
            children: [
              /* {
                path: 'nueva-venta',
                element: <NewSale />,
                permission: ConstantPermissions.ORDM_ORDERS_STORE_WEB
              }, */
              {
                path: 'venta-web',
                children: [
                  {
                    path: '',
                    element: <WebOrderList />,
                    permission: ConstantPermissions.SALE_ORDERS_INDEX, // TODO cambiar cuando se cree el permiso
                  },
                  {
                    path: ':id',
                    element: <NewSale />,
                  },
                ],
              },
              {
                path: 'aprobados-regla',
                element: <RuleApprovedOrderList />,
                permission: ConstantPermissions.SALE_ORDERS_INDEX,
              },
              {
                path: 'nota-credito',
                children: [
                  {
                    path: '',
                    element: <CreditNoteList />,
                    permission: ConstantPermissions.SALE_CREDIT_NOTE_INDEX, // TODO cambiar cuando se cree el permiso
                  },
                  {
                    path: ':id',
                    element: <NCredito />,
                  },
                ],
              },
              {
                path: 'nota-credito-sobrantes',
                children: [
                  {
                    path: '',
                    element: <CreditNoteLeftOverList />,
                    permission: ConstantPermissions.SALE_CREDIT_NOTE_INDEX, // TODO cambiar cuando se cree el permiso
                  },
                  {
                    path: ':id',
                    element: <NCLeftOvers />,
                  },
                ],
              },
              {
                path: 'pedidos-retenidos',
                children: [
                  {
                    path: '',
                    element: <OrderMovilList />,
                    permission: ConstantPermissions.ORDM_ORDERS_INDEX,
                  },
                  {
                    //?esta ruta lo usa el seguimiento  de vendedor y marca en los modales, cuando haces click a un pedido
                    path: ':id',
                    element: <OrdmOrderDetailShared />,
                  },
                ],
              },
              {
                path: 'pedidos-retenidos/web',
                children: [
                  {
                    path: '',
                    element: <OrderWebList />,
                    permission: ConstantPermissions.ORDM_ORDERS_INDEX,
                  },
                  {
                    path: ':id',
                    element: <OrdmOrderDetailShared />,
                  },
                ],
              },
              {
                path: 'pedidos-comprometidos',
                children: [
                  {
                    path: '',
                    element: <OrderCommittedList />,
                    permission: ConstantPermissions.ORDM_ORDERS_INDEX,
                  },
                  {
                    path: ':id',
                    element: <OrdmOrderDetailShared />,
                  },
                ],
              },
              {
                path: 'pedidos',
                children: [
                  {
                    path: '',
                    element: <SaleOrderList />,
                    permission: ConstantPermissions.SALE_ORDERS_INDEX,
                  },
                  {
                    path: ':id',
                    element: <SaleOrderDetail />, //observacion
                  },
                ],
              },
              {
                path: 'pedidos-diarios',
                children: [
                  {
                    path: '',
                    element: <DigitateOrderList />,
                    permission: ConstantPermissions.SALE_ORDERS_INDEX, // TODO cambiar cuando se cree el permiso
                  },
                  {
                    path: ':id',
                    element: <SaleOrderDetail />, //observacion
                  },
                ],
              },
              {
                path: 'productos-vendidos',
                children: [
                  {
                    path: '',
                    element: <SaleProductList />,
                    permission: ConstantPermissions.SALE_ORDERS_INDEX, // TODO cambiar cuando se cree el permiso
                  },
                ],
              },
              {
                path: 'productos-comprometidos',
                children: [
                  {
                    path: '',
                    element: <ProductCommittedList />,
                    permission: ConstantPermissions.SALE_ORDERS_INDEX, // TODO cambiar cuando se cree el permiso
                  },
                  {
                    path: ':id/:id2',
                    element: <ProductCommittedDetail />,
                  },
                ],
              },
              {
                path: 'buscar-documento',
                children: [
                  {
                    path: '',
                    element: <SearchDocumentList />,
                    permission: ConstantPermissions.SALE_ORDERS_INDEX, // TODO cambiar cuando se cree el permiso
                  },
                ],
              },
              {
                path: 'buscar-documento',
                children: [
                  {
                    path: '',
                    element: <SearchDocumentList />,
                    permission: ConstantPermissions.ORDM_ORDERS_INDEX, // TODO cambiar cuando se cree el permiso
                  },
                ],
              },
            ],
          },
          {
            path: 'datos-maestros',
            children: [
              {
                path: 'jefe-supervisor',
                element: <BossSupervisorList />,
                permission: ConstantPermissions.BASE_SUPERVISORS_INDEX,
              },
              {
                path: 'supervisor',
                children: [
                  {
                    path: '',
                    element: <SupervisorList />,
                    permission: ConstantPermissions.BASE_SUPERVISORS_INDEX,
                  },
                  {
                    path: ':id',
                    element: <SupervisorDetail />,
                  },
                ],
              },
              {
                path: 'vendedores',
                children: [
                  {
                    path: '',
                    element: <SellerList />,
                    permission: ConstantPermissions.BASE_SELLERS_INDEX,
                  },
                  {
                    path: ':id',
                    element: <SellerDetail />,
                  },
                ],
              },
              {
                path: 'mesa',
                element: <BureauList />,
                permission: ConstantPermissions.BASE_BUREAUS_INDEX,
              },
              {
                path: 'cliente-mesa',
                element: <CustomerBureauList />,
                permission: ConstantPermissions.BASE_CUSTOMER_BUREAUS_INDEX,
              },
              {
                path: 'carteras',
                element: <CustomerPortfolioList />,
                permission: ConstantPermissions.BASE_CUSTOMER_PORTFOLIOS_INDEX,
              },
              {
                path: 'cartera-mesa',
                element: <CustomerPortfolioBureauList />,
                permission: ConstantPermissions.BASE_CUSTOMER_PORTFOLIO_BUREAUS_INDEX,
              },
              {
                path: 'cartera-diaria',
                children: [
                  {
                    path: '',
                    element: <DailyCustomerPortfolioList />,
                    permission: ConstantPermissions.BASE_DAILY_CUSTOMER_PORTFOLIOS_INDEX,
                  },
                  {
                    path: ':id',
                    element: <DailyCustomerPortfolioDetail />, //observacion
                  },
                ],
              },
              {
                path: 'rutas',
                element: <RouteList />,
                permission: ConstantPermissions.BASE_ROUTES_INDEX,
              },
              {
                path: 'capas',
                element: <LayerList />,
                permission: ConstantPermissions.BASE_ROUTES_INDEX,
              },
              {
                path: 'agrupamiento-de-capas',
                element: <LayerDivitionList />,
                permission: ConstantPermissions.BASE_ROUTES_INDEX,
              },
              {
                path: 'zonas',
                element: <ZoneList />,
                permission: ConstantPermissions.BASE_ZONES_INDEX,
              },
              {
                path: 'cliente-ruta',
                element: <CustomerRouteList />,
                permission: ConstantPermissions.BASE_CUSTOMER_ROUTES_INDEX,
              },
              {
                path: 'fuerza-venta',
                children: [
                  {
                    path: '',
                    element: <SaleForceList />,
                    permission: ConstantPermissions.BASE_SALE_FORCES_INDEX,
                  },
                  {
                    path: ':id',
                    element: <SaleForceDetail />, //observacion
                  },
                ],
              },
              {
                path: 'dia-visita',
                element: <VisitDayList />,
                permission: ConstantPermissions.BASE_VISIT_DAYS_INDEX,
              },
              {
                path: 'cuota',
                children: [
                  {
                    path: '',
                    element: <QuotaList />,
                    permission: ConstantPermissions.BASE_QUOTAS_INDEX,
                  },
                  {
                    path: ':id',
                    element: <QuotaDetail />, //observacion
                  },
                ],
              },
              {
                path: 'sire',
                element: <SalesSireView />,
                permission: ConstantPermissions.SALE_SIRE_CONCILIATIONS_INDEX,
              },
            ],
          },
          {
            path: 'cuotas',
            children: [
              {
                path: 'proveedores',
                children: [
                  {
                    path: '',
                    element: <CPQuoteList />,
                    permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                  },
                  {
                    path: 'winter',
                    children: [
                      {
                        path: 'cuota-cliente',
                        element: <CPQuoteWinterList />,
                        permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                      },
                      {
                        path: 'cuota-vendedor',
                        element: <CPSellerWinterList />,
                        permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                      },
                      {
                        path: 'cobertura-referencia',
                        element: <CPCWinterList />,
                        permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                      },
                      {
                        path: 'cuota-rebate',
                        element: <CPCWinterRebate />,
                        permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                      }
                    ],
                  },
                  {
                    path: 'colgate',
                    children: [
                      {
                        path: 'colgate-bimestral',
                        children: [
                          {
                            path: 'coverage',
                            element: <CoverageColgateList />,
                            permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                          },
                          {
                            path: 'periods',
                            element: <PeriodColgateList />,
                            permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                          },
                          {
                            path: 'cuota-compra',
                            element: <PurchasingQuotaList />,
                            permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                          },
                          {
                            path: 'cuota-categoria',
                            element: <CategoryQuotaList />,
                            permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                          },
                          {
                            path: 'cuota-grupo',
                            children: [
                              {
                                path: '',
                                element: <GroupQuotaList />,
                                permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                              },
                              {
                                path: ':id',
                                element: <GroupDetailQuotaList />,
                              }
                            ]
                          },
                        ],
                      },
                      {
                        path: 'colgate-periodo',
                        children: [
                          {
                            path: 'cuota-compra',
                            element: <CuotaCompra />,
                            permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                          },
                          {
                            path: 'cuota-categoria',
                            element: <CuotaCategoria />,
                            permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                          },
                          {
                            path: 'cuota-grupo',
                            children: [
                              {
                                path: '',
                                element: <CuotaGrupo />,
                                permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                              },
                              {
                                path: ':id',
                                element: <CuotaGrupoDetail />,
                              }
                            ]
                          },
                        ],
                      },
                    ],
                  },
                  {
                    path: 'softys',
                    children: [
                      {
                        path: 'quota-category',
                        element: <QuotaCategorySoftys />,
                        permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                      },
                    ],
                  },
                  {
                    path: 'unilever-cuotas',
                    children: [
                      {
                        path: 'cuota-compras',
                        element: <QuotaComprasUnilever />,
                        permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                      },
                      {
                        path: 'cuota-ventas',
                        element: <QuotaVentasUnilever />,
                        permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                      },
                    ],
                  },
                  {
                    path: 'verdum',
                    children: [
                      {
                        path: 'cuota-sede',
                        element: <QuotaSede />,
                        permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                      },
                      {
                        path: 'cuota-supervisor',
                        element: <QuotaSupervisor />,
                        permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                      },
                      {
                        path: 'cuota-vendedor',
                        element: <QuotaVendedor />,
                        permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                      },
                      {
                        path: 'cuota-zonal',
                        element: <QuotaZonal />,
                        permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                      },
                    ],
                  },
                  {
                    path: 'clorox',
                    children: [
                      {
                        path: 'cuota-sede-clorox',
                        element: <QuotaSedeClorox />,
                        permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                      },
                      {
                        path: 'cuota-supervisor-clorox',
                        element: <QuotaSupervisorClorox />,
                        permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                      },
                      {
                        path: 'cuota-vendedor-clorox',
                        element: <QuotaVendedorClorox />,
                        permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                      },
                      {
                        path: 'cuota-zonal-clorox',
                        element: <QuotaZonalClorox />,
                        permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                      },
                      {
                        path: 'cuota-productos-clorox',
                        element: <QuotaProductosClorox />,
                        permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                      },
                      {
                        path: 'indicador-clorox',
                        element: <CloroxIndicators />,
                        permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                      },
                      {
                        path: 'linealidad-clorox',
                        element: <CloroxLinealities />,
                        permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                      },
                      {
                        path: 'grupo-productos-clorox',
                        children: [
                          {
                            path: '',
                            element: <CloroxProductGroups />,
                            permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                          },
                          {
                            path: ':id',
                            element: <CloroxProductGroupsDetail />,
                            permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                          },
                        ],
                      },
                    ],
                  },
                  {
                    path: 'arcor',
                    children: [
                      {
                        path: 'division-arcor',
                        element: <ArcorDivisions />,
                        permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                      },
                      {
                        path: 'indicador-arcor',
                        element: <ArcorIndicators />,
                        permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                      },
                      {
                        path: 'cuota-arcor-zonal',
                        element: <QuotaArcorZonals />,
                        permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                      },
                      {
                        path: 'cuota-arcor-sede',
                        element: <QuotaArcorSedes />,
                        permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                      },
                      {
                        path: 'cuota-arcor-supervisor',
                        element: <QuotaArcorSupervisors />,
                        permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                      },
                      {
                        path: 'cuota-arcor-vendedores',
                        element: <QuotaArcorSellers />,
                        permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                      },
                      {
                        path: 'cuota-arcor-productos',
                        element: <QuotaArcorProducts />,
                        permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                      },
                    ],
                  },
                  {
                    path: 'winter-cuotas',
                    children: [
                      {
                        path: 'indicador-winter',
                        element: <WinterIndicators />,
                        permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                      },
                      {
                        path: 'cuota-winter-zonal',
                        element: <QuotaWinterZonals />,
                        permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                      },
                      {
                        path: 'cuota-winter-sede',
                        element: <QuotaWinterSedes />,
                        permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                      },
                      {
                        path: 'cuota-winter-jefe-venta',
                        element: <QuotaWinterBossSale />,
                        permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                      },
                      {
                        path: 'cuota-winter-supervisor',
                        element: <QuotaWinterSupervisors />,
                        permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                      },
                      {
                        path: 'cuota-winter-vendedores',
                        element: <QuotaWinterSellers />,
                        permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                      },
                      {
                        path: 'panetones',
                        children: [
                          {
                            path: 'grupo-productos',
                            children: [
                              {
                                path: '',
                                element: <PanettoneProductGroups />,
                                permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                              },
                              {
                                path: ':id',
                                element: <PanettoneProductGroupsDetail />,
                                permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                              },
                            ],
                          },
                          {
                            path: 'indicador-panetones',
                            element: <PanettoneIndicators />,
                            permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                          },
                          {
                            path: 'cuota-zonal-panetones',
                            element: <PanettoneQuotaZonals />,
                            permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                          },
                          {
                            path: 'cuota-sede-panetones',
                            element: <PanettoneQuotaSedes />,
                            permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                          },
                          {
                            path: 'cuota-jefe-venta-panetones',
                            element: <PanettoneQuotaBossSale />,
                            permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                          },
                          {
                            path: 'cuota-supervisor-panetones',
                            element: <PanettoneQuotaSupervisors />,
                            permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                          },
                          {
                            path: 'cuota-vendedor-panetones',
                            element: <PanettoneQuotaSellers />,
                            permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            path: 'comision',
            children: [
              {
                path: 'trabajo-campo',
                children: [
                  {
                    path: 'supervisor',
                    children: [
                      {
                        path: '',
                        element: <FormSupervisor />,
                        permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                      },
                      {
                        path: ':id',
                        element: <FormSupervisorDetail />,
                      }
                    ]
                  },
                  {
                    path: 'diccionario',
                    element: <FormDiccionario />,
                    permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                  },
                ],
              },
              {
                path: 'regla-parametro',
                children: [
                  {
                    path: 'supervisor-parametro',
                    element: <SupervisorParametro />,
                    permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                  },
                  {
                    path: 'bonos',
                    element: <BonosVentas />,
                    permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                  },
                  {
                    path: 'colores',
                    element: <BonosColores />,
                    permission: ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_INDEX,
                  },
                  {
                    path: 'commissions',
                    element: <Commissions />,
                    permission: ConstantPermissions.SALE_COMISIONES_INDEX,
                  },
                  {
                    path: 'group-commission',
                    element: <GroupCommissions />,
                    permission: ConstantPermissions.SALE_COMISIONES_INDEX,
                  },
                  {
                    path: 'type-worker',
                    element: <TypeWorker />,
                    permission: ConstantPermissions.SALE_COMISIONES_INDEX,
                  },
                  {
                    path: 'bono-zone',
                    element: <BonoZone />,
                    permission: ConstantPermissions.SALE_COMISIONES_INDEX,
                  },
                ],
              },
            ],
          },
          {
            path: 'incentivos',
            children: [
              {
                path: 'tipo-incentivo',
                element: <TipoIncentivo />,
                permission: ConstantPermissions.INCENTIVOS_TIPO_INCENTIVOS_INDEX,
              },
              {
                path: 'canal-incentivo',
                element: <CanalIncentivo />,
                permission: ConstantPermissions.INCENTIVOS_TIPO_INCENTIVOS_INDEX,
              },
              {
                path: 'colgate',
                children: [
                  {
                    path: 'cuotas-incentivos',
                    element: <BaseCuotasIncentivos />,
                    permission: ConstantPermissions.INCENTIVOS_TIPO_INCENTIVOS_INDEX,
                  },
                  {
                    path: 'reglas',
                    children: [
                      {
                        path: '',
                        element: <BaseRules />,
                        permission: ConstantPermissions.INCENTIVOS_TIPO_INCENTIVOS_INDEX,
                      },
                      {
                        path: ':id',
                        element: <BaseRulesDetail />,
                      }
                    ]
                  },
                  {
                    path: 'rango-reglas',
                    element: <BaseRangeRules />,
                    permission: ConstantPermissions.INCENTIVOS_TIPO_INCENTIVOS_INDEX,
                  },
                  {
                    path: 'colgate-supervisor',
                    children: [
                      {
                        path: '',
                        element: <SupervisorColgate />,
                        permission: ConstantPermissions.INCENTIVOS_TIPO_INCENTIVOS_INDEX,
                      },
                      {
                        path: ':id',
                        element: <SupervisorColgateDetalle />,
                      }
                    ]
                  },
                  {
                    path: 'mecanica-ventas',
                    children: [
                      {
                        path: '',
                        element: <MecanicaVentas />,
                        permission: ConstantPermissions.INCENTIVOS_TIPO_INCENTIVOS_INDEX,
                      },
                      {
                        path: ':id',
                        element: <MecanicaVentaDetails />,
                      }
                    ]
                  },
                ],
              },
              {
                path: 'unilever',
                children: [
                  {
                    path: 'grupo-incentivo',
                    children: [
                      {
                        path: '',
                        element: <GrupoIncentivo />,
                        permission: ConstantPermissions.INCENTIVOS_TIPO_INCENTIVOS_INDEX,
                      },
                      {
                        path: ':id',
                        element: <GrupoIncentivoDetails />,
                      }
                    ]
                  },
                  {
                    path: 'cuota-unilever-vendedor',
                    element: <CuotaVendedor />,
                    permission: ConstantPermissions.INCENTIVOS_TIPO_INCENTIVOS_INDEX,
                  },
                  {
                    path: 'unilever-supervisor',
                    children: [
                      {
                        path: '',
                        element: <SupervisorUnilever />,
                        permission: ConstantPermissions.INCENTIVOS_TIPO_INCENTIVOS_INDEX,
                      },
                      {
                        path: ':id',
                        element: <SupervisorUnileverDetalle />,
                      }
                    ],
                  },
                ],
              },
              {
                path: 'softys',
                children: [
                  {
                    path: 'softy-candado',
                    element: <SoftyCandado />,
                    permission: ConstantPermissions.INCENTIVOS_TIPO_INCENTIVOS_INDEX,
                  },
                  {
                    path: 'softy-grupo',
                    children: [
                      {
                        path: '',
                        element: <SoftyGrupo />,
                        permission: ConstantPermissions.INCENTIVOS_TIPO_INCENTIVOS_INDEX,
                      },
                      {
                        path: ':id',
                        element: <SoftyGrupoDetails />,
                      }
                    ]
                  },
                  {
                    path: 'softy-cuota-vendedor',
                    element: <SoftyCuotaVendedor />,
                    permission: ConstantPermissions.INCENTIVOS_TIPO_INCENTIVOS_INDEX,
                  },
                  {
                    path: 'softy-supervisor',
                    children: [
                      {
                        path: '',
                        element: <SoftySupervisor />,
                        permission: ConstantPermissions.INCENTIVOS_TIPO_INCENTIVOS_INDEX,
                      },
                      {
                        path: ':id',
                        element: <SoftySupervisorDetalle />,
                      }
                    ],
                  },
                ],
              },
            ],
          },
          {
            path: 'consultas',
            children: [
              {
                path: 'fuera-de-ruta-cartera',
                element: <FueraRutaCartera />,
                permission: ConstantPermissions.BASE_CUSTOMER_PORTFOLIO_BUREAUS_INDEX,
              },
            ],
          },
        ],
      },
      {
        path: 'bancos',
        children: [
          {
            path: 'datos-maestros2',
            children: [
              {
                path: 'extracto-bancario',
                element: <StatementBank />,
                permission: ConstantPermissions.PYMT_DEPOSITS_INDEX,
              },
            ],
          },
          {
            path: 'operaciones',
            children: [
              {
                path: 'cierre-de-caja',
                children: [
                  {
                    path: '',
                    element: <ClosingList />,
                    permission: ConstantPermissions.PYMT_CLOSINGS_INDEX,
                  },
                  {
                    path: ':id',
                    element: <ClosingShow />,
                    permission: ConstantPermissions.PYMT_CLOSINGS_SHOW,
                  },
                ],
              },
              {
                path: 'pago-recibidos',
                children: [
                  {
                    path: '',
                    element: <PaymentReceivedList />,
                    permission: ConstantPermissions.PYMT_RECEIVED_PAYMENTS_INDEX,
                  },
                  {
                    path: ':id',
                    element: <PaymentRecivedDetail />,
                    permission: ConstantPermissions.PYMT_RECEIVED_PAYMENTS_STORE,
                  },
                ],
              },
              {
                path: 'pagos-efectuados',
                children: [
                  {
                    path: '',
                    element: <PaymentMadeList />,
                    permission: ConstantPermissions.PYMT_ACCOMPLISHED_PAYMENTS_INDEX,
                  },
                  {
                    path: ':id',
                    element: <PaymentMadeDetail />,
                    permission: ConstantPermissions.PYMT_ACCOMPLISHED_PAYMENTS_STORE,
                  },
                ],
              },
              {
                path: 'listado-cuentas',
                element: <AccountListView />,
                permission: ConstantPermissions.PYMT_ACCOMPLISHED_PAYMENTS_INDEX,
              },
              {
                path: 'depositos',
                children: [
                  {
                    path: '',
                    element: <DepositList />,
                    permission: ConstantPermissions.PYMT_DEPOSITS_INDEX,
                  },
                  {
                    path: ':id',
                    element: <NewDepositView />,
                    permission: ConstantPermissions.PYMT_DEPOSITS_STORE,
                  },
                ],
              },
              {
                path: 'aplicar-nc',
                children: [
                  {
                    path: '',
                    element: <ApplicateNCList />,
                    permission: ConstantPermissions.PYMT_RECEIVED_PAYMENTS_MASSIVE_APPLY,
                  },
                  {
                    path: ':id',
                    element: <ApplicateNC />,
                    permission: ConstantPermissions.PYMT_DEPOSITS_STORE,
                  },
                ],
              },
              {
                path: 'reconciliacion',
                children: [
                  {
                    path: '',
                    element: <ReconciliationList />,
                    permission: ConstantPermissions.PYMT_RECEIVED_PAYMENTS_MASSIVE_APPLY,
                  },
                  {
                    path: ':id',
                    element: <NewReconciliation />,
                    permission: ConstantPermissions.PYMT_RECEIVED_PAYMENTS_MASSIVE_APPLY,
                  },
                ],
              },
            ],
          },
          {
            path: 'datos-maestros',
            children: [
              {
                path: 'pago-recibidos',
                children: [
                  {
                    path: '',
                    element: <PaymentRealizedReceivedList />,
                    permission: ConstantPermissions.PYMT_RECEIVED_PAYMENTS_INDEX,
                  },
                  {
                    path: ':id',
                    element: <PaymentRealizedReceivedDetail />,
                    permission: '',
                  },
                ],
              },
              {
                path: 'pagos-efectuados',
                children: [
                  {
                    path: '',
                    element: <PaymentRealizedMadeList />,
                    permission: ConstantPermissions.PYMT_ACCOMPLISHED_PAYMENTS_INDEX,
                  },
                  {
                    path: ':id',
                    element: <PaymentRealizedMadeDetail />,
                    permission: '',
                  },
                ],
              },
              {
                path: 'cuenta-corriente',
                children: [
                  {
                    path: '',
                    element: <CurrentAccout />,
                    permission: ConstantPermissions.PYMT_RECEIVED_PAYMENTS_INDEX,
                  },
                  {
                    path: ':DocEntry',
                    element: <CurrentAccoutDetail />,
                    permission: '',
                  },
                ],
              },
            ],
          },
        ],
      },

      //movil
      {
        path: 'movil',
        children: [
          {
            path: 'seguimiento',
            children: [
              {
                path: 'vendedor',
                element: <TracingSellerList />,
                permission: ConstantPermissions.BASE_QUOTAS_SELLER_GROUPED,
              },
              {
                path: 'marca',
                element: <TracingMarkList />,
                permission: ConstantPermissions.BASE_QUOTAS_MARK_GROUPED,
              },
            ],
          },
          {
            path: 'clientes',
            element: <CustomerMobileList />,
            permission: ConstantPermissions.ORDM_CUSTOMERS_INDEX,
          },
          {
            path: 'puntos',
            element: <MarkedList />,
            permission: ConstantPermissions.BASE_CUSTOMER_ROUTES_MARKED_POINTS,
          },
          {
            path: 'punto-dia',
            element: <MarkedDayList />,
            permission: ConstantPermissions.BASE_CUSTOMER_ROUTES_MARKED_OF_DAY,
          },
          {
            path: 'logueos',
            element: <LogList />,
            permission: ConstantPermissions.BASE_LOGS_INDEX,
          },
        ],
      },
      {
        path: 'reparto',
        children: [
          {
            path: 'operaciones',
            children: [
              {
                path: 'programacion',
                children: [
                  {
                    path: '',
                    element: <ProgrammingList />,
                    permission: ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_INDEX,
                  },
                  {
                    path: ':id',
                    element: <ProgrammingDetail />, //observacion
                  },
                  {
                    path: 'agregar/:id',
                    element: <ProgrammingDetail />, //observacion
                  },
                  {
                    path: 'dividir/:id',
                    element: <ProgrammingDetail />, //observacion
                  },
                ],
              },
              {
                path: 'configuracion',
                children: [
                  {
                    path: '',
                    element: <ConfigList />,
                    permission: ConstantPermissions.DELIV_JORNADAS_INDEX,
                  },
                  {
                    path: ':id',
                    element: <ConfigListDetail />,
                  },
                ],
              },
              {
                path: 'jefe-jornada',
                children: [
                  {
                    path: '',
                    element: <WorkingBossList />,
                    permission: ConstantPermissions.DELIV_JORNADAS_INDEX,
                  },
                  {
                    path: ':id',
                    element: <WorkingBossDetail />,
                  },
                ],
              },
              {
                path: 'cancel-liquidation-day',
                element: <CancelLiquidationList />,
                permission: ConstantPermissions.ADMIN_ACCESS_USER,
              },
              {
                path: 'avance-reparto',
                children: [
                  {
                    path: '',
                    element: <DistributionTrackingList />,
                    permission: ConstantPermissions.DELIV_SHEET_DISTRIBUTIONS_INDEX,
                  },
                  {
                    path: ':id',
                    element: <DistributionTrackingDetail />,
                  },
                  {
                    path: ':id/:id2',
                    element: <DistributionTrackingDetail />,
                  },
                ],
              },
              {
                path: 'liquidacion',
                element: <LiquidationList />,
                permission: ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_LIQUIDATION_INDEX,
              },
            ],
          },
          {
            path: 'datos-maestros',
            children: [
              {
                path: 'personal-distribucion',
                element: <DistributionStaffList />,
                permission: ConstantPermissions.PROG_DISTRIBUTION_STAFF_INDEX,
              },
              {
                path: 'public-personal-distribucion',
                element: <PublicDistributionStaffList />,
                permission: ConstantPermissions.PROG_DISTRIBUTION_STAFF_INDEX,
              },
              {
                path: 'estado-empleado',
                element: <EmployeeStatusList />,
                permission: ConstantPermissions.BASE_EMPLOYEE_STATUSES_INDEX,
              },
              {
                path: 'posicion-empleado',
                element: <EmployeePositionList />,
                permission: ConstantPermissions.BASE_EMPLOYEE_POSITIONS_INDEX,
              },
              {
                path: 'vehiculo',
                element: <VehicleList />,
                permission: ConstantPermissions.PROG_VEHICLES_INDEX,
              },
              {
                path: 'public-vehiculo',
                element: <PublicVehicleList />,
                permission: ConstantPermissions.PROG_VEHICLES_INDEX,
              },
            ],
          },
          {
            path: 'consultas',
            children: [
              {
                path: 'avance-facturacion',
                element: <AdvanceInvoiceList />,
                permission: ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_INDEX,
              },
              {
                path: 'avance-liquidacion',
                element: <SettlementAdvance />,
                permission: ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_INDEX,
              },
            ],
          },
        ],
      },
      {
        path: 'jornadas',
        children: [
          {
            path: 'jornada-diarias',
            element: <WorkingDayList />,
            permission: ConstantPermissions.ORDM_WORK_DAYS_INDEX,
          },
          {
            path: 'cierre-jornada',
            element: <CloseWorkDayList />,
            permission: ConstantPermissions.ORDM_CLOSING_WORK_DAYS_INDEX,
          },
        ],
      },
      {
        path: 'cuotas',
        children: [
          {
            path: 'datos-maestros',
            children: [
              {
                path: 'cuota',
                element: <Quota />,
                permission: ConstantPermissions.BASE_QUOTAS_INDEX,
              },
              {
                path: 'zonal',
                element: <ZoneQuota />,
                permission: ConstantPermissions.BASE_QUOTAS_INDEX,
              },
            ],
          },
        ],
      },
      {
        path: 'comisiones',
        children: [
          {
            path: 'datos-maestros',
            children: [
              {
                path: 'rango',
                element: <RangeList />,
                permission: ConstantPermissions.COM_RANGES_INDEX,
              },
              {
                path: 'cuota-zona',
                element: <QuotaZoneList />,
                permission: ConstantPermissions.COM_ZONE_QUOTAS_INDEX,
              },
              {
                path: 'grupo-proveedor',
                children: [
                  {
                    path: '',
                    element: <ProviderGroupList />,
                    permission: ConstantPermissions.COM_ZONE_QUOTAS_INDEX,
                  },
                  {
                    path: ':id',
                    element: <ProviderGroupDetail />,
                  },
                ],
              },
            ],
          },
          {
            path: 'operaciones',
            children: [
              {
                path: 'incentivo',
                children: [
                  {
                    path: '',
                    element: <IncentiveList />,
                    permission: ConstantPermissions.COM_RANGES_INDEX,
                  },
                  {
                    path: 'nuevo',
                    element: <IncentiveNewUpdate />,
                    permission: ConstantPermissions.COM_RANGES_INDEX,
                  },
                  {
                    path: ':id/editar',
                    element: <IncentiveNewUpdate />,
                    permission: ConstantPermissions.COM_RANGES_INDEX,
                  },
                  {
                    path: ':id',
                    element: <IncentiveRp />,
                    permission: ConstantPermissions.COM_RANGES_INDEX,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: 'reportes',
        children: [
          {
            path: 'ventas-ruta',
            element: <RouteSales />,
            permission: ConstantPermissions.REPORT_ROUTE_SALES_INDEX,
          },
          {
            path: 'ventas-excel',
            element: <SalesExcel />,
            permission: ConstantPermissions.REPORT_SALES_EXCEL_INDEX,
          },
          {
            path: 'whatsapp',
            children: [
              {
                path: 'actividad',
                element: <ActivityWhatsapp />,
                permission: ConstantPermissions.REPORT_WHATSAPP_INDEX,
              },
              {
                path: 'contacto',
                element: <ContactWhatsapp />,
                permission: ConstantPermissions.REPORT_WHATSAPP_INDEX,
              },
              {
                path: 'archivo-reporte',
                children: [
                  {
                    path: '',
                    element: <FileWhatsapp />,
                    permission: ConstantPermissions.REPORT_WHATSAPP_INDEX,
                  },
                  {
                    path: ':id',
                    element: <FileDetailWhatsapp />,
                  },
                ],
              },
            ],
          },
          {
            path: 'analisis',
            children: [
              {
                path: '',
                element: <AnalisisList />,
                permission: ConstantPermissions.REPORT_PROGRAM_ANALYSIS_INDEX,
              },
              {
                path: ':id',
                element: <AnalisisListDetail />,
              },
            ],
          },
        ],
      },
      {
        path: 'impresion',
        children: [
          {
            path: 'usuarios',
            children: [
              {
                path: '',
                element: <PrintList />,
                permission: ConstantPermissions.PRT_DOCUMENTS_INDEX,
              },
              {
                path: ':id',
                element: <PrintDetail />, //observacion
              },
            ],
          },
          {
            path: 'guia-remision',
            children: [
              {
                path: '',
                element: <ReferalGuide />,
                permission: ConstantPermissions.PRT_GUIDE_SERIES_INDEX,
              },
              {
                path: ':id',
                element: <ReferalGuideDetail />, //observacion
              },
            ],
          },
        ],
      },
      {
        path: 'configuracion',
        children: [
          {
            path: 'usuarios',
            children: [
              {
                path: '',
                element: <UserList />,
                permission: ConstantPermissions.OAUTH_USERS_INDEX,
              },
              {
                path: ':id',
                element: <UserDetail />, //observacion
              },
            ],
          },
          {
            path: 'notificaciones',
            children: [
              {
                path: '',
                element: <NotificationList />,
                permission: ConstantPermissions.OAUTH_USERS_INDEX,
              },
              {
                path: ':id',
                element: <NotificationDetail />, //observacion
              },
            ],
          },
          {
            path: 'empresa',
            element: <CompanyList />,
            permission: ConstantPermissions.BASE_CONFIGURATIONS_INDEX,
          },
          {
            path: 'roles',
            children: [
              {
                path: '',
                element: <RoleList />,
                permission: ConstantPermissions.OAUTH_ROLES_INDEX,
              },
              {
                path: ':id',
                element: <RoleDetail />, //observacion
              },
            ],
          },
          {
            path: 'feriado',
            element: <HolidayList />,
            permission: ConstantPermissions.BASE_HOLIDAYS_INDEX,
          },
          {
            path: 'variable',
            element: <VariableList />,
            permission: ConstantPermissions.BASE_CONFIGURATIONS_INDEX,
          },
          {
            path: 'aplicaciones-movil',
            element: <MobileAppList />,
            permission: ConstantPermissions.BASE_CONFIGURATIONS_INDEX,
          },
        ],
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default TvendoRoutes;
